/**
 * Turkish relative-time formatter.
 * Converts an ISO timestamp into a human-friendly "X dk önce" style string.
 *
 * Examples:
 *   now              -> "az önce"
 *   45 seconds ago   -> "az önce"
 *   5 minutes ago    -> "5 dk önce"
 *   90 minutes ago   -> "1 saat önce"
 *   yesterday        -> "dün HH:mm"
 *   >2 days          -> "12 Nis 14:30"
 *   >1 year          -> "12 Nis 2025"
 */
export function formatLastSeenTr(isoOrDate) {
  if (!isoOrDate) return '';
  const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
  if (isNaN(d.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);

  if (diffSec < 60) return 'az önce';
  if (diffMin < 60) return `${diffMin} dk önce`;
  if (diffHr < 24 && d.toDateString() === now.toDateString()) {
    return `${diffHr} saat önce`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) {
    return `dün ${d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`;
  }

  if (now.getFullYear() === d.getFullYear()) {
    return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' })
      + ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  }
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' });
}

/**
 * Compose a "last seen" subtitle for offline users.
 * Returns "son görülme: 5 dk önce" or empty string if no timestamp.
 */
export function formatLastSeenSubtitleTr(isoOrDate) {
  const rel = formatLastSeenTr(isoOrDate);
  return rel ? `son görülme ${rel}` : '';
}
